<div class='card' [ngClass]="state === 'Passed' ? 'passed' : 'failed'"
    [routerLink]="['/v3/dashboard', module.name, module.module_id]">
    <h3>{{module.name}}</h3>

    <p>{{state}}</p>
    <p [ngClass]="timeDifferenceGreaterThan1Hour ? 'date-error': ''">{{date}}</p>
</div>